import './ContractStatusChoices.scss'

import React from 'react'
import {
  AGENT_CONTRACT_STATUS,
  AGENT_CONTRACT_STATUS_LEASE,
} from 'common/constants'
import cx from 'classnames'
import { connect } from 'react-redux'
import { setField } from 'manager/redux/referral_status'

const ContractStatusButtons = ({ choices, selected, setField }) => {
  return (
    <div className="ContractStatusChoices">
      <div className="subtitle">CONTRACT STATUS</div>
      <div className="choice-btns">
        {choices.map(({ label, value }) => (
          <button
            key={value}
            onClick={() => setField('contract_status', value)}
            className={cx('StatusChoice', {
              'StatusChoice__selected': selected === value
            })}>
            {label}
          </button>
        ))}
      </div>
    </div>
  )
}

const selector = state => {
  const isLease = _.get(state, ['referral', 'referral', 'is_lease'], false)
  const choices = isLease ? AGENT_CONTRACT_STATUS_LEASE : AGENT_CONTRACT_STATUS
  const selected = _.get(state, ['referralStatus', 'contract_status'])

  return {
    choices,
    selected,
  }
}

const actions = { setField }

export const ContractStatusChoices = connect(selector, actions)(ContractStatusButtons)
